module.exports = [{"type":"title","text":"2024-06-13"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續幣本位新增系列交易API"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-06-13.json
// module id = vBmL
// module chunks = 3